import { TalentPool, TalentPoolBrief } from '@recruitee/http-types';

export enum TalentPoolsScope {
  Default = 'not_archived',
  Archived = 'archived',
}

export type TalentPoolsFetchCollectionResponse = {
  talentPools: TalentPool[];
};

export type TalentPoolsBriefFetchCollectionResponse = {
  talentPools: TalentPoolBrief[];
};

export type TalentPoolsResponse = {
  talentPool: TalentPool;
};
